import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule, Platform } from '@ionic/angular';
import { MensagemProvider } from 'src/app/services/mensagem/mensagem';
import { NoticiaProvider } from 'src/app/services/noticia/noticia';
import { OracaoProvider } from 'src/app/services/oracao/oracao';
import { UserProvider } from 'src/app/services/user/user';

@Component({
  selector: 'botao-icone',
  templateUrl: 'botao-icone.html',
  styleUrls: ['botao-icone.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonicModule
  ]
})
export class BotaoIconeComponent {

  @Input()
  config: any;

  constructor(public mensagemProvider: MensagemProvider,
    public oracaoProvider: OracaoProvider,
    public noticiaProvider: NoticiaProvider,
    public userProvider: UserProvider,
    public platform: Platform) {

  }

  getBackground() {
    if (this.config.icon_backcolor_transparent == '1') {
      return;
    } else {
      return this.config.icon_backcolor;
    }
  }

  getSize() {
    return this.config.tamanho == 1 ? '48%' : '98%';
  }

  getFontColor() {
    return this.config.font_color;
  }

  getFontSize() {
    if (this.platform.width() >= 768) {
      return (this.config.font_size * 1.4) + 'px';
    } else {
      return this.config.font_size + 'px';
    }

  }

  isIcone() {
    if (this.config.icon && this.config.icon.includes('http')) {
      return false;
    } else {
      return true;
    }
  }

  getFontWeight() {
    return +this.config.font_weight + 100;
  }

  getFontAlign() {
    return this.config.font_align;
  }

  getBorder() {
    return this.config.border_size + 'px solid ' + this.config.border_color;
  }

  getIconSize() {
    if (this.platform.width() >= 768) {
      return (this.config.icon_size * 2) + 'px';
    } else {
      return this.config.icon_size + 'px';
    }
  }

  getIcon() {
    if (this.config.icon.includes(' fa-')) {
      return this.config.icon;
    } else {
      return 'fas fa-' + this.config.icon;
    }
  }

}
